// Per-sensor color assignment for the trend overlay, persisted in localStorage.
// Palette avoids yellows/oranges/reds — those are the transient severity colors.

export const SENSOR_COLOR_PALETTE = [
  '#1f77b4', // blue
  '#2ca02c', // green
  '#9467bd', // purple
  '#17becf', // cyan
  '#e377c2', // pink
  '#8c564b', // brown
  '#7f7f7f', // grey
  '#3b5998', // dark blue
  '#66c2a5', // teal
  '#a6761d', // olive
];

const STORAGE_KEY = 'trendOverlaySensorColors';

export const loadSensorColors = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

export const saveSensorColor = (sensorId, color) => {
  const colors = { ...loadSensorColors(), [String(sensorId)]: color };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(colors));
  } catch (e) {
    // Storage full or blocked — colors still apply for this session.
  }
  return colors;
};

export const getSensorColor = (sensorId, index, overrides) =>
  (overrides || {})[String(sensorId)]
  || SENSOR_COLOR_PALETTE[index % SENSOR_COLOR_PALETTE.length];
